import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "380",
      height: "456",
      viewBox: "0 0 380 456",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("g", {
        filter: "url(#2nfc1eh8b__filter0_f)",
        children: _jsx("path", {
          d: "M263.883 435.939C316.508 435.939 359.169 430.348 359.169 423.451C359.169 416.555 316.508 410.964 263.883 410.964C211.258 410.964 168.597 416.555 168.597 423.451C168.597 430.348 211.258 435.939 263.883 435.939Z",
          fill: "#333333",
          fillOpacity: "0.2"
        })
      }), _jsx("path", {
        d: "M313.508 413.39L299.261 417.696C298.166 418.026 296.985 417.587 296.373 416.621C295.761 415.656 295.868 414.401 296.635 413.553L304.704 404.641L306.885 398.501L312.136 402.392L315.551 408.088C316.125 409.039 316.228 410.203 315.828 411.239C315.429 412.276 314.572 413.07 313.508 413.39Z",
        fill: "#714288"
      }), _jsx("path", {
        d: "M312.141 402.392L304.709 404.641C304.709 404.641 290.314 374.103 275.727 340.848C267.254 321.579 258.702 301.393 252.839 285.71C241.119 283.737 236.554 268.661 237.102 258.092L242.53 249.16C242.925 241.447 241.514 230.32 250.92 222.444C254.961 221.645 263.928 217.798 268.132 216.669C275.135 214.78 284.669 211.668 290.136 221.852C292.11 227.203 294.084 232.934 295.935 239.025C301.639 257.766 301.2 272.626 298.896 291.327C298.042 298.232 296.922 305.63 295.797 313.95C298.874 317.709 301.447 321.854 303.451 326.279C306.102 331.916 307.761 337.967 308.356 344.167C309.614 358.109 308.874 391.71 312.141 402.392Z",
        fill: "#AD84C1"
      }), _jsx("path", {
        d: "M225.757 426.243H210.864C209.719 426.245 208.714 425.483 208.407 424.381C208.1 423.28 208.566 422.108 209.546 421.518L219.86 415.319L223.837 411.926L227.642 415.319L229.261 421.76C229.534 422.838 229.292 423.982 228.607 424.859C227.922 425.736 226.87 426.246 225.757 426.243Z",
        fill: "#714288"
      }), _jsx("path", {
        d: "M252.839 285.71C250.372 292.17 247.564 298.113 245.047 303.958C243.621 307.277 242.239 310.369 240.941 313.239C236.164 323.759 232.626 330.663 232.626 330.663C234.768 335.418 238.548 352.058 232.626 371.79C226.704 391.522 227.642 415.319 227.642 415.319H219.86C200.244 341.435 201.729 235.272 201.729 235.272C201.729 235.272 236.1 208.709 256.471 232.027C261.732 255.182 258.174 271.664 252.839 285.71Z",
        fill: "#CAABD8"
      }), _jsx("path", {
        d: "M252.839 285.71C250.372 292.171 247.564 298.114 245.047 303.958C243.621 307.277 242.239 310.369 240.941 313.239C260.789 261.243 223.176 235.81 223.176 235.81H223.531H223.739C234.731 235.426 245.675 234.178 256.471 232.076C261.732 255.182 258.174 271.664 252.839 285.71Z",
        fill: "#AD84C1"
      }), _jsx("path", {
        d: "M303.47 326.314L300.228 327.764C298.833 328.39 297.206 328.204 295.989 327.279C294.772 326.353 294.158 324.836 294.39 323.325L295.807 313.955C298.89 317.723 301.466 321.878 303.47 326.314Z",
        fill: "#9362AF"
      }), _jsx("path", {
        d: "M298.906 291.327C298.595 249.584 268.857 229.152 268.857 229.152C276.114 227.209 283.229 224.771 290.151 221.853C292.125 227.204 294.099 232.934 295.95 239.025C301.664 257.747 301.215 272.626 298.906 291.327Z",
        fill: "#9362AF"
      }), _jsx("path", {
        d: "M275.727 340.848C267.254 321.579 258.702 301.393 252.839 285.71C255.923 277.592 258.411 268.661 258.944 258.092C258.998 258.689 263.301 306.365 275.727 340.848Z",
        fill: "#9362AF"
      }), _jsx("rect", {
        x: "0.458496",
        y: "1.09814",
        width: "153.976",
        height: "96.1265",
        rx: "20.15",
        fill: "#DFD7E8"
      }), _jsx("path", {
        d: "M93.3167 71.767C104.278 71.767 113.164 62.8861 113.164 51.9311C113.164 40.976 104.278 32.0952 93.3167 32.0952C82.3551 32.0952 73.4689 40.976 73.4689 51.9311C73.4689 62.8861 82.3551 71.767 93.3167 71.767Z",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "11.1572",
        y: "12.7524",
        width: "46.2589",
        height: "28.8809",
        rx: "6.05",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "128.63",
        y: "78.5923",
        width: "18.2045",
        height: "11.3679",
        rx: "2.38",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "81.5719",
        y: "12.7524",
        width: "46.2589",
        height: "4.02931",
        rx: "2.01465",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "81.5719",
        y: "21.0874",
        width: "46.2589",
        height: "4.02932",
        rx: "2.01466",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "11.1572",
        y: "57.3267",
        width: "5.7293",
        height: "28.8809",
        rx: "2.13",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "23.6422",
        y: "62.436",
        width: "5.72931",
        height: "23.7715",
        rx: "1.93",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "36.1322",
        y: "69.0791",
        width: "5.72931",
        height: "17.1283",
        rx: "1.64",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "48.6172",
        y: "75.52",
        width: "5.7293",
        height: "10.6873",
        rx: "1.3",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "58.5214",
        y: "121.573",
        width: "92.3549",
        height: "57.6582",
        rx: "12.09",
        fill: "#DFD7E8"
      }), _jsx("rect", {
        x: "111.319",
        y: "134.845",
        width: "26.416",
        height: "1.91353",
        rx: "0.956764",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "181.447",
        y: "23.104",
        width: "92.3548",
        height: "57.6582",
        rx: "12.09",
        fill: "#DFD7E8"
      }), _jsx("rect", {
        x: "232.029",
        y: "49.0156",
        width: "30.6106",
        height: "19.1109",
        rx: "4.01",
        fill: "#C6B7D6"
      }), _jsx("path", {
        d: "M204.828 66.7263C213.005 66.7263 219.633 60.1021 219.633 51.9308C219.633 43.7594 213.005 37.1353 204.828 37.1353C196.652 37.1353 190.024 43.7594 190.024 51.9308C190.024 60.1021 196.652 66.7263 204.828 66.7263Z",
        fill: "#C6B7D6"
      }), _jsx("path", {
        d: "M241.677 40.6564C243.623 40.6564 245.2 39.0799 245.2 37.1351C245.2 35.1903 243.623 33.6138 241.677 33.6138C239.731 33.6138 238.153 35.1903 238.153 37.1351C238.153 39.0799 239.731 40.6564 241.677 40.6564Z",
        fill: "#C6B7D6"
      }), _jsx("path", {
        d: "M253.89 40.6564C255.836 40.6564 257.414 39.0799 257.414 37.1351C257.414 35.1903 255.836 33.6138 253.89 33.6138C251.944 33.6138 250.367 35.1903 250.367 37.1351C250.367 39.0799 251.944 40.6564 253.89 40.6564Z",
        fill: "#C6B7D6"
      }), _jsx("path", {
        d: "M283.405 179.819C280.296 182.06 276.956 183.963 273.442 185.495C265.226 166.754 265.053 149.7 263.883 134.87C263.735 133.02 263.572 131.21 263.39 129.445C262.531 121.962 260.372 114.687 257.009 107.947C257.957 108.325 258.906 108.762 259.856 109.259C275.204 117.214 284.146 140.127 288.641 156.111C289.204 158.123 289.697 160.057 290.122 161.778C291.765 168.597 289.109 175.732 283.405 179.819Z",
        fill: "#FFB0B0"
      }), _jsx("path", {
        d: "M256.999 107.902L248.329 110.2L262.64 188.059L273.442 185.47L279.364 155.548L256.999 107.902Z",
        fill: "#FFB0B0"
      }), _jsx("path", {
        d: "M100.576 58.569V66.0703L94.7379 61.4639L91.9942 58.9487C89.6607 56.8111 88.4428 53.7182 88.6928 50.5646L89.2307 43.5268C89.2924 42.7688 89.761 42.104 90.4545 41.7908C90.7224 41.6746 91.0112 41.6141 91.3033 41.6133C91.9607 41.6133 92.5793 41.9242 92.9713 42.4517L96.544 47.2652C96.9114 47.7463 97.5349 47.9553 98.1182 47.7929H98.1479C98.6022 47.6629 99.091 47.7473 99.4755 48.022C99.8599 48.2967 100.098 48.7317 100.122 49.2034L100.576 58.569Z",
        fill: "#EFA08D"
      }), _jsx("path", {
        d: "M277.099 192.917C275.727 190.407 274.518 187.926 273.442 185.47C264.199 164.401 265.137 145.443 263.38 129.4C262.521 121.918 260.362 114.642 256.999 107.902C251.85 105.858 246.27 105.134 240.769 105.796L187.527 116.602C164.857 113.564 134.004 98.1469 134.004 98.1469L100.576 58.5688L94.7379 61.4638L106.764 96.4454C113.098 114.88 125.986 130.347 142.981 139.91L179.533 160.471C185.41 181.801 195.215 216.6 201.739 235.272C201.739 235.272 210.128 236.204 223.186 235.765H223.541H223.749C234.741 235.382 245.685 234.134 256.481 232.032C268.026 229.805 279.31 226.395 290.156 221.857C286.49 211.916 282.127 202.245 277.099 192.917Z",
        fill: "#FFCCCC"
      }), _jsx("path", {
        d: "M235.927 163.795C231.159 166.24 226.001 167.836 220.684 168.509C205.06 170.31 191.727 162.029 188.326 143.461C186.264 132.157 187.103 124.226 187.532 116.597C187.823 111.374 187.922 106.289 186.767 100.351C182.424 78.0742 183.175 65.7692 187.986 58.5638C190.838 54.283 195.127 51.8022 200.624 50.0958C213.356 46.1504 229.004 55.0277 233.253 69.7542C236.707 81.7287 236.608 92.8303 240.773 105.791C241.791 108.969 243.009 112.079 244.42 115.102C252.469 132.3 257.389 153.073 235.927 163.795Z",
        fill: "#9873B9"
      }), _jsx("path", {
        d: "M290.151 221.852C279.305 226.39 268.021 229.8 256.476 232.027C245.68 234.129 234.736 235.377 223.744 235.76C233.001 235.306 260.542 226.597 261.939 210.894C263.365 194.865 254.813 183.113 223.447 179.192C196.834 175.868 190.779 151.796 190.779 151.796C198.216 169.284 217.165 173.18 235.932 163.8C257.394 153.073 252.474 132.3 244.43 115.103C243.015 112.081 241.794 108.973 240.774 105.796C246.275 105.134 251.854 105.858 257.004 107.902C260.367 114.642 262.526 121.918 263.385 129.4C265.142 145.443 264.204 164.416 273.447 185.47C274.523 187.936 275.732 190.402 277.104 192.917C282.128 202.244 286.488 211.913 290.151 221.852Z",
        fill: "#FFB0B0"
      }), _jsx("path", {
        d: "M283.405 179.818C280.296 182.059 276.956 183.962 273.442 185.495C265.226 166.754 265.053 149.699 263.883 134.869C263.957 135.313 269.104 164.835 282.492 163.508C286.44 163.119 288.167 160.125 288.631 156.111C289.194 158.123 289.687 160.056 290.112 161.777C291.758 168.594 289.106 175.728 283.405 179.818Z",
        fill: "#EA8C8C"
      }), _jsx("path", {
        d: "M235.928 163.795C231.159 166.24 226.001 167.836 220.684 168.51C252.267 155.445 215.72 133.114 206.867 111.261C198.013 89.4077 220.492 72.9402 212.566 61.449C204.641 49.9578 187.996 58.554 187.996 58.554C190.848 54.2732 195.137 51.7925 200.634 50.0861C213.366 46.1406 229.014 55.0179 233.263 69.7444C236.717 81.7189 236.618 92.8205 240.783 105.781C241.797 108.962 243.012 112.076 244.42 115.103C252.469 132.3 257.389 153.073 235.928 163.795Z",
        fill: "#6E4896"
      }), _jsx("rect", {
        x: "85.9441",
        y: "137.977",
        width: "15.1992",
        height: "9.48885",
        rx: "1.99",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "111.319",
        y: "142.134",
        width: "26.416",
        height: "1.91356",
        rx: "0.956779",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "111.319",
        y: "149.423",
        width: "26.416",
        height: "1.91356",
        rx: "0.956779",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "111.319",
        y: "156.713",
        width: "26.416",
        height: "1.91356",
        rx: "0.956779",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "111.319",
        y: "164.002",
        width: "26.416",
        height: "1.91356",
        rx: "0.956779",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "85.9441",
        y: "153.295",
        width: "15.1992",
        height: "9.48888",
        rx: "1.99",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "68.1048",
        y: "137.977",
        width: "15.1992",
        height: "9.48885",
        rx: "1.99",
        fill: "#C6B7D6"
      }), _jsx("rect", {
        x: "68.1048",
        y: "153.295",
        width: "15.1992",
        height: "9.48888",
        rx: "1.99",
        fill: "#C6B7D6"
      }), _jsx("path", {
        d: "M217.772 416.019L219.618 417.765C219.74 417.879 219.799 418.044 219.777 418.21C219.756 418.375 219.656 418.519 219.509 418.599L217.353 419.792C217.153 419.9 216.907 419.868 216.741 419.713L215.034 418.105C214.916 417.996 214.856 417.839 214.869 417.679C214.883 417.52 214.969 417.375 215.103 417.287L217.126 415.965C217.328 415.831 217.596 415.854 217.772 416.019Z",
        fill: "#CAABD8"
      }), _jsx("path", {
        d: "M214.441 418.278L216.287 420.019C216.409 420.133 216.469 420.299 216.449 420.464C216.428 420.63 216.33 420.776 216.183 420.857L214.022 422.046C213.823 422.155 213.575 422.123 213.41 421.967L211.703 420.359C211.586 420.249 211.526 420.092 211.541 419.932C211.555 419.772 211.642 419.628 211.777 419.54L213.795 418.219C213.998 418.086 214.266 418.111 214.441 418.278Z",
        fill: "#CAABD8"
      }), _jsx("path", {
        d: "M303.145 406.2L305.266 407.595C305.406 407.687 305.493 407.84 305.501 408.007C305.508 408.174 305.436 408.334 305.306 408.439L303.386 409.982C303.214 410.133 302.961 410.145 302.774 410.012L300.8 408.725C300.667 408.637 300.581 408.492 300.567 408.332C300.554 408.173 300.614 408.015 300.731 407.906L302.488 406.254C302.667 406.083 302.94 406.061 303.145 406.2Z",
        fill: "#CAABD8"
      }), _jsx("path", {
        d: "M300.253 408.986L302.375 410.382C302.514 410.474 302.601 410.627 302.609 410.794C302.617 410.96 302.544 411.121 302.414 411.225L300.495 412.769C300.318 412.914 300.067 412.926 299.878 412.799L297.904 411.511C297.77 411.424 297.684 411.28 297.67 411.121C297.657 410.962 297.718 410.806 297.835 410.698L299.592 409.041C299.771 408.867 300.048 408.845 300.253 408.986Z",
        fill: "#CAABD8"
      }), _jsx("defs", {
        children: _jsxs("filter", {
          id: "2nfc1eh8b__filter0_f",
          x: "148.597",
          y: "390.964",
          width: "230.572",
          height: "64.9749",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [_jsx("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix"
          }), _jsx("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "BackgroundImageFix",
            result: "shape"
          }), _jsx("feGaussianBlur", {
            stdDeviation: "10",
            result: "effect1_foregroundBlur"
          })]
        })
      })]
    }))
  });
};
export default Component;
